<div class="navbar navbar-expand-sm sub-nav-wrapper sub-navigation">
    <h2 class="sub-header-text">
        <div>
            <span>{{ title }}</span>
        </div>
        <span class="theme-left mobile-sub-navigation" (click)="goBack()"></span>
    </h2>
</div>
